import {observer} from "mobx-react";
import {ReportFields} from "./ReportFields";
import GeneralDialog from "../../GeneralDialog";
import React from "react";
import {useStores} from "../../../../Hooks";
import {AutomateReporting} from "./AutomateReporting";

export const GenerateReportsModal = observer(({}) =>{
    const {workspaceManagementStore, modalStore} = useStores();

    const renderBody =()=>{
        return(
            <div className="flex flex-col mt-0">
                {renderExportButton()}
                <AutomateReporting autoReportSetting={'AutomaticUserReport'}/>
        <ReportFields fieldsType={'SubWorkspaceReportColumns'} title={'workspaces'}/>
        <ReportFields fieldsType={'MemberReportColumns'} title={'members'}/>
    </div>
        )
    }
    const renderTitle = () => {
        return (
            <div className="text-center text-lg font-bold absolute top-5">
                Report Settings
            </div>
        )
    }

    const isConfirmDisabled = () => {
        const {currentMemberColumns, currentWorkspaceColumns} = workspaceManagementStore.getCurrentColumns;
        if (currentWorkspaceColumns.length === 0 && currentMemberColumns.length === 0) {
            return true
        }
        const autoSettings = workspaceManagementStore.editedSubDomainReportsSettings.AutomaticUserReport
        if (autoSettings.IsOn === true &&(autoSettings.StartDay === null || !autoSettings.Frequency || !autoSettings.AttachedUserEmail)){
            return true
        }
        return false
    }
    const onConfirm = async() => {
        const result = await workspaceManagementStore.saveSubWorkspaceReportsSettings();
    }
    const onEnter = () =>{
        workspaceManagementStore.buildSubDomainNewReportSettings()
    }
    const specialOnClose = () => {
        workspaceManagementStore.buildSubDomainNewReportSettings()
        modalStore.isGenerateSubWorkspaceReportsModalOpen = false
    }

    const renderExportButton = ()=>{
        return (
            <div className="flex flex-row justify-end">
                <button
                    className="absolute top-5 right-5 text-link-normal border-1 border-link-normal px-3 py-1 cursor-pointer rounded-3 hover:bg-link-hover transition-colors duration-200"
                    onClick={workspaceManagementStore.downloadUserReport}
                >
                    Export
                </button>
            </div>
        )
    }
    return (
        <>
            <GeneralDialog
                openControl='isGenerateSubWorkspaceReportsModalOpen'
                className='procedure-option-dialog sub-workspace-popup'
                disableBackdropClick={true}
                onEnter={onEnter}
                title={renderTitle()}
                headerClassName="h-10 mb-0 mt-0"
                body={renderBody()}
                isConfirmDisabled={isConfirmDisabled()}
                confirmText={'Save Settings'}
                onConfirm={onConfirm}
                specialOnClose = {specialOnClose}
            />
        </>
    )
})